import Emitter from 'component-emitter';
import { HubConnection } from '@microsoft/signalr';

import { CashbackFromBackend } from 'app/api/services/client/client-info/types';

export class CashbackExperienceConnection {
  constructor(hubConnection: HubConnection, emmitter: Emitter) {
    hubConnection.on('CashbackExperienceUpdated', (payload: CashbackFromBackend) => emmitter.emit(
      'update-cashback-experience',
      { ...payload }),
    );
  }
}
